module.exports = __webpack_public_path__ + "static/sec5-bg-12f34ffb0e1087b9aa3c904304147cd2.jpg";